
import Vue from 'vue'

export default Vue.extend({
  name: 'ErrorAlert',
  props: ['showError', 'errorMessage'],

})
